import NavbarItem from '@ss/mtd-vue/es/components/navbar-item';

// todo 增加点击空白区域关闭下拉
var __vue_render__ = function __vue_render__() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('navbar-item', _vm._b({ staticClass: "mtd-navbar-icon-item", attrs: { "visible": _vm.visible, "route": _vm.route }, on: { "update:visible": _vm.handleVisibleChange, "click": _vm.handleClick } }, 'navbar-item', _vm.$attrs, false), [_c('i', { staticClass: "mtd-navbar-icon-item-icon", class: _vm.icon }), _c('template', { slot: "dropdown" }, [_vm._t("dropdown")], 2)], 2);
};
var __vue_staticRenderFns__ = [];

export default {
  render: __vue_render__,

  staticRenderFns: __vue_staticRenderFns__,

  name: 'MtdNavbarIconItem',
  components: {
    NavbarItem: NavbarItem
  },
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    route: [String, Object]
  },
  methods: {
    handleVisibleChange: function handleVisibleChange(v) {
      this.$emit('update:visible', v);
    },
    handleClick: function handleClick(e) {
      this.$emit('click', e);
    }
  }
};